import { render, staticRenderFns } from "./WebsiteFtpUsersPanel.vue?vue&type=template&id=25cf53ed&"
import script from "./WebsiteFtpUsersPanel.vue?vue&type=script&lang=ts&"
export * from "./WebsiteFtpUsersPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports